var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _FadingAdapter_fading;
import { FadingEnvelope } from "@opendaw/lib-dsp";
export class FadingAdapter {
    constructor(fading) {
        _FadingAdapter_fading.set(this, void 0);
        __classPrivateFieldSet(this, _FadingAdapter_fading, fading, "f");
    }
    get inField() { return __classPrivateFieldGet(this, _FadingAdapter_fading, "f").in; }
    get outField() { return __classPrivateFieldGet(this, _FadingAdapter_fading, "f").out; }
    get inSlopeField() { return __classPrivateFieldGet(this, _FadingAdapter_fading, "f").inSlope; }
    get outSlopeField() { return __classPrivateFieldGet(this, _FadingAdapter_fading, "f").outSlope; }
    get in() { return __classPrivateFieldGet(this, _FadingAdapter_fading, "f").in.getValue(); }
    get out() { return __classPrivateFieldGet(this, _FadingAdapter_fading, "f").out.getValue(); }
    get inSlope() { return __classPrivateFieldGet(this, _FadingAdapter_fading, "f").inSlope.getValue(); }
    get outSlope() { return __classPrivateFieldGet(this, _FadingAdapter_fading, "f").outSlope.getValue(); }
    get hasFading() { return FadingEnvelope.hasFading(this); }
    copyTo(target) {
        target.in.setValue(this.in);
        target.out.setValue(this.out);
        target.inSlope.setValue(this.inSlope);
        target.outSlope.setValue(this.outSlope);
    }
    reset() {
        __classPrivateFieldGet(this, _FadingAdapter_fading, "f").in.setValue(0.0);
        __classPrivateFieldGet(this, _FadingAdapter_fading, "f").out.setValue(0.0);
        __classPrivateFieldGet(this, _FadingAdapter_fading, "f").inSlope.setValue(0.75);
        __classPrivateFieldGet(this, _FadingAdapter_fading, "f").outSlope.setValue(0.25);
    }
}
_FadingAdapter_fading = new WeakMap();
